var BLOCK_ID_USER_MAIN = 'userMain';
var BLOCK_ID_USER_ACTIONS = 'userActions';
var BLOCK_ID_USER_AUTH = 'userAuth';
export { BLOCK_ID_USER_MAIN, BLOCK_ID_USER_ACTIONS, BLOCK_ID_USER_AUTH };